import { ViewRow, WpDisplayConfig, WpViewTable } from '../../core';
import { Sort, SortOrder } from '../../grid';
import { ColumnId } from '../model/column-id.model';

import { determineRowLabel } from './determine-row-label.function';

export function dataForColumn(
    column: ColumnId,
    data: ViewRow,
    table: WpViewTable,
    config: WpDisplayConfig,
): {
    value: any;
    type: 'string' | 'number';
} {
    switch (column) {
        case ColumnId.LEFT:
            return {
                value: determineRowLabel(data, table, config),
                type: 'string',
            };
        case ColumnId.WINNING_PERCENTAGE:
            return {
                value:
                    data.row.individual?.winning ??
                    data.row.peopleDetail?.winning,
                type: 'number',
            };
        case ColumnId.ASSESSED_COMMITS:
            return {
                value: data.row.assessedGoalCommitments?.length,
                type: 'number',
            };
        case ColumnId.EXCLUDED_COMMITS:
            return {
                value: data.row.excludedGoalCommitments?.length,
                type: 'number',
            };
        default:
            return { value: null, type: null };
    }
}

export function sortColumn(
    valA: string | number | any,
    valB: string | number | any,
    type: 'string' | 'number',
    order: SortOrder,
): number {
    if (type === 'number') {
        valA = valA == null ? Number.MIN_SAFE_INTEGER : valA;
        valB = valB == null ? Number.MIN_SAFE_INTEGER : valB;
    } else {
        valA = valA == null ? '' : valA;
        valB = valB == null ? '' : valB;
    }
    return type === 'number'
        ? order === SortOrder.ASC
            ? valA - valB
            : valB - valA
        : order === SortOrder.ASC
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
}

export function _sortRows(
    rows: ViewRow[],
    nextSortOptions: Sort,
    table: WpViewTable,
    config: WpDisplayConfig,
): ViewRow[] {
    const nextFilteredRows = [...rows];
    nextFilteredRows.sort((a, b) => {
        const av = dataForColumn(
            nextSortOptions.columnId as ColumnId,
            a,
            table,
            config,
        );
        const bv = dataForColumn(
            nextSortOptions.columnId as ColumnId,
            b,
            table,
            config,
        );
        let result = sortColumn(
            av.value,
            bv.value,
            av.type,
            nextSortOptions.order,
        );
        // TODO write a recursion for this later
        if (result === 0) {
            // fallback sort by name asc
            const av3 = dataForColumn(ColumnId.LEFT, a, table, config);
            const bv3 = dataForColumn(ColumnId.LEFT, b, table, config);
            result = sortColumn(av3.value, bv3.value, av3.type, SortOrder.ASC);
        }
        return result;
    });
    return nextFilteredRows;
}

export function sortRows(
    rows: ViewRow[],
    nextSortOptions: Sort,
    table: WpViewTable,
    config: WpDisplayConfig,
): ViewRow[] {
    const sortNestedRows = (e: ViewRow): void => {
        if (e.children == null) {
            return;
        }
        e.children = _sortRows(e.children, nextSortOptions, table, config);
        e.children.map((e) => {
            const n = { ...e };
            sortNestedRows(n);
            return n;
        });
    };
    const nextFilteredRows = _sortRows(rows, nextSortOptions, table, config);
    nextFilteredRows.map((e) => {
        const n = { ...e };
        sortNestedRows(n);
        return n;
    });
    return nextFilteredRows;
}
